import { Utils } from "@/plugins/utils";
import router from '@/router';
import moment from "moment"

export default {
    namespaced: true,
	state: {
        lstMb1: [],
        mb1: {
            mb1agente: null,
            mb1agencia: null,
            mb1conta: null,
            mb1criacao: null,
            mb1caminho: null,
            mb1nome: null
        },
        insert: false,
        update: false,
        loading: false,
        itemsPerPage: 20,
        search: "",
        hasNext: false,
        lastUpdatedRegister: null,
        mb1criacao: null,
        hasConciliation: false,
        conciliationData: null,
        shouldReimport: false,
        sinceDate: moment().subtract(1, 'month').format("YYYY-MM-DD 00:00"),
        untilDate: moment().format("YYYY-MM-DD 23:59"),
        mb1conc: [],
	},
    getters:{
        getMb1:(state) => state.mb1,
        getUpdate:(state) => state.update,
        getMb1Extrato:(state) => state.mb1.mb1extrato,
        getItemsPerPage:(state) => state.itemsPerPage,
        getSearch(state) {
            return state.search || "";
        },
        getFn3(state, getters, rootState, rootGetters) {
            return rootGetters['fn3/getFn3']
        }
    },
    mutations: {
        initForm(state){
            const dataEmiss = state.mb1?.mb1criacao || null
            state.insert = true
            state.update = false
            state.mb1.mb1agente = null
            state.mb1.mb1criacao = dataEmiss || null
            state.mb1.mb1caminho = null
            state.mb1.mb1nome = null    
        },
        set(state, mb1) {
            state.update = !!mb1
            state.mb1.mb1agente = mb1?.mb1agente ?? null
            state.mb1.mb1criacao = mb1?.mb1criacao ?? state.mb1.mb1criacao ?? null
            state.mb1.mb1caminho = mb1?.mb1caminho ?? null
            state.mb1.mb1nome = mb1?.mb1nome ?? null
        },
        setParamsDataTable(state, payload) {
            state.lstMb1 = payload.items
            state.itemsPerPage = payload.limit
            state.hasNext = payload.hasNext
        },
        setLstMb1(state, lstMb2) {
            state.lstMb1 = lstMb2
        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        setSearch(state, search) {
            state.search = search;
        },
        setMb1(state, mb1) {
            state.mb1 = mb1
        },
        setMb1KeepingBank(state, mb1) {
            const current = state.mb1 || {}
            state.mb1 = {
                ...mb1,
                mb1agente: mb1?.mb1agente ?? current.mb1agente,
                mb1agencia: mb1?.mb1agencia ?? current.mb1agencia,
                mb1conta: mb1?.mb1conta ?? current.mb1conta,
                mb1extrato: mb1?.mb1extrato ?? current.mb1extrato
            }
        },
        setMb2DataInicio(state, value) {
            state.mb2dataini = value;
        },
        setMb2DataFim(state, value) {
            state.mb2datafim = value;
        },
        setLastUpdatedRegister(state, lastUpdatedRegister) {
            state.lastUpdatedRegister = lastUpdatedRegister
        },
        setHasConciliation(state, value) {
            state.hasConciliation = value;
        },
        setConciliationData(state, data) {
            state.conciliationData = data;
        },
        setShouldReimport(state, val) {
            state.shouldReimport = val
        },
        setMb1Extrato(state, mb1extrato) {
           state.mb1.mb1extrato = mb1extrato;
        },
        setMb1AgentInfo(state, { mb1agente, mb1agencia, mb1conta }) {
            state.mb1.mb1agente = mb1agente
            state.mb1.mb1agencia = mb1agencia
            state.mb1.mb1conta = mb1conta
        }
    },
    actions: {
        initForm({ commit }) {
            commit('initForm')
        },
        async find({ commit, dispatch }, mb1extrato) {
            commit("setLoading", true)
            commit("initForm")
            await this._vm.$axios.get(`/Financial/BankTransactionDocuments/Find/${mb1extrato}`)
                .then(response => {
                    let mb1 = Utils.ValidateAxiosResponse(response.data);
                    commit("set", mb1)
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                });
            commit("setLoading", false)
        },
        async save({ getters, dispatch }) {
            if (getters.getUpdate) {
                return await dispatch("update")
            }
            return await dispatch("insert")
        },
        async insert({ commit, getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.post("/Financial/BankTransactionDocuments/Insert", getters.getMb1)
                .then(response => {
                    commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
                    commit("setMb1", {})
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload;
        },
        async update({ commit, getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.put("/Financial/BankTransactionDocuments/Update", getters.getMb1)
                .then(response => {
                    commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload
        },
        async delete({ getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, { root: true })
            await this._vm.$axios.delete(`/Financial/BankTransactionDocuments/Delete/${getters.getMb1Extrato}`)
                .then(response => {
                    Utils.ValidateAxiosResponse(response.data);
                    router.push("/oryxpdv/movimentacoes-bancarias")
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
        },        
        async search({ commit, dispatch, state, getters }, { limit = 20, page = 1 }) {
            commit("setLoading", true);

            let fn3 = getters.getFn3

            const bankingAgent = fn3?.fn3agente ?? ""

            let urlChipParams = ""

            for (const status of state.mb1conc) {
                urlChipParams += `&statusMb1conc=${status}`
            }

            let payload = await this._vm.$axios.get(
                `/Financial/BankTransactionDocuments/Search?` +
                `search=${getters.getSearch}` +
                `&bankingAgent=${bankingAgent}` +
                `&sinceDate=${state.sinceDate}` +
                `&untilDate=${state.untilDate}` +
                `&limit=${limit}` +
                `&page=${page}` +
                urlChipParams
            )
            .then(response => {
                let payload = Utils.ValidateAxiosResponse(response.data);
                commit("setParamsDataTable", payload);
                return true;
            })
            .catch((error) => {
                commit("setLstMb1", []);
                dispatch("parameters/openDialog", {
                titleText: "Erro",
                titleColor: "red",
                text: error.message
                }, { root: true });
                return false;
            });

            commit("setLoading", false);

            return payload;
        },
        async import({ dispatch, commit }, { bank, agence, account, formData }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Importando", indeterminate: true }, 
                { root: true });

            try {
                const response = await this._vm.$axios.post(
                    `/Financial/BankTransactionDocuments/Import?bank=${bank}&agence=${agence}&account=${account}`,
                    formData
                );

                const data = response.data;
                const statement = data.statement;
                const pairs = data.pairs || [];
                const mb1 = data.mb1;

                commit("setConciliationData", { statement, pairs })
                commit("setHasConciliation", pairs.length > 0);
                commit("setMb1Extrato", mb1?.mb1extrato);

                if (pairs.length > 0) {
                    commit("setMb1AgentInfo", { mb1agente: bank, mb1agencia: agence, mb1conta: account });
                    router.push({
                        path: `/oryxpdv/movimentacao-bancaria/${mb1?.mb1extrato}`,
                        query: { bank, agence, account }
                    });
                } else {
                    dispatch("parameters/openDialog", {
                        titleText: "Aviso",
                        titleColor: "orange",
                        text: "Todas as movimentações deste arquivo já foram importadas."
                    }, { root: true });
                }
                return { statement, pairs };
            } catch (error) {
                dispatch("parameters/openDialog", {
                titleText: "Erro",
                titleColor: "red",
                text: error.message
                }, { root: true });
                return null;
            } finally {
                dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true });
            }
        },
        async searchManualConciliation({ dispatch }, { bank, agence, account, value, search }) {

            try {
                let response = await this._vm.$axios.get(
                    `/Financial/BankTransactionDocuments/SearchTransactionsManual`,
                    {
                        params: { bank, agence, account, value, search }
                    }
                );

                Utils.ValidateAxiosResponse(response.data);

                dispatch("parameters/openGlobalLoading", { 
                    showLoadingGlobal: false, 
                    text: "Buscando" 
                }, { root: true });

                return response.data;

            } catch (error) {
                dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true });

                return null;
            }
        },
       async conciliate({ commit, dispatch }, conciliation) {
        dispatch("parameters/openGlobalLoading", { 
            showLoadingGlobal: true, 
            text: "Conciliando", 
            indeterminate: true 
        }, { root: true });

        let payload = await this._vm.$axios.post(
            "/Financial/BankTransactionDocuments/Conciliation",
            conciliation
        )
        .then(response => {
            const validated = Utils.ValidateAxiosResponse(response.data);
            commit("setLastUpdatedRegister", validated);
            commit("setMb1KeepingBank", validated);
            return validated;
        })
        .catch(error => {
            dispatch("parameters/openDialog", {
            titleText: "Erro",
            titleColor: "red",
            text: error.message
            }, { root: true });
            return null;
        });

        dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true });
        return payload;
        },
       async revertConciliation({ commit, dispatch }, mb1) {
            dispatch("parameters/openGlobalLoading", { 
                showLoadingGlobal: true, 
                text: "Revertendo Conciliação", 
                indeterminate: true 
            }, { root: true });

            let payload = await this._vm.$axios.delete(
                "/Financial/BankTransactionDocuments/RevertConciliation/",
                { data: mb1 }
            )
            .then(response => {
                const validated = Utils.ValidateAxiosResponse(response.data);
                commit("setLastUpdatedRegister", validated);
                commit("setMb1KeepingBank", {});
                return validated;
            })
            .catch(error => {
                dispatch("parameters/openDialog", {
                titleText: "Erro",
                titleColor: "red",
                text: error.message
                }, { root: true });
                return null;
            });

            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true });
            return payload;
        },
        async getConciliationByExtrato({ dispatch, commit }, { mb1extrato }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Recuperando arquivo", indeterminate: true }, { root: true });

            try {
                const response = await this._vm.$axios.get(
                    `/Financial/BankTransactionDocuments/GetConciliationByExtrato`,
                    { params: { mb1extrato } }
                );

                const data = response.data;
                const statement = data.statement;
                const pairs = data.pairs || [];
                const mb1 = data.mb1;

                commit("setConciliationData", { statement, pairs })
                commit("setHasConciliation", pairs.length > 0);
                commit("setMb1", mb1);

                if (pairs.length > 0) {
                    router.push(`/oryxpdv/movimentacao-bancaria/${mb1?.mb1extrato}`);
                } else {
                    dispatch("parameters/openDialog", {
                        titleText: "Aviso",
                        titleColor: "orange",
                        text: "Todas as movimentações deste arquivo já foram importadas."
                    }, { root: true });
                }
                return { statement, pairs };
            } catch (error) {
                dispatch("parameters/openDialog", {
                titleText: "Erro",
                titleColor: "red",
                text: error.message
                }, { root: true });
                return null;
            } finally {
                dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true });
            }
        },
        async updateMb1conc({ dispatch }, { mb1extrato, mb1conc }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            try {
                const response = await this._vm.$axios.put(
                    `/Financial/BankTransactionDocuments/UpdateMb1conc?mb1extrato=${mb1extrato}&mb1conc=${mb1conc}`
                )
                Utils.ValidateAxiosResponse(response.data)
                return true
            } catch (error) {
                dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            } finally {
                dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            }
        },
    }
}